export default __webpack_public_path__ + "static/media/mongo.793bb073.svg";